<template>
	<div>
		<div class="podia">
			<div class="conbg" :style="{'width':width+'px','height':height+'px'}">
				<div class="titletop flex">
					<div class="title">{{title}}</div>
					<img src="../assets/icon/close.png" @click="closeDialog" style="width: 14px;height: 14px;"
						class="closeimg pointer" />
				</div>
				<div class="contents">
					{{content}}
				</div>
				<div class="footbotom flex flex-c-c">
					<div class="btn flex flex-c pointer" @click="closeDialog">返回</div>
					<div class="btn flex flex-c btn2 pointer" @click="confirmDialog">确认</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			width: {
				type: Number,
				default: 200
			},
			height: {
				type: Number,
				default: 200
			},
			title: {
				type: String,
				default: ''
			},
			content: {
				type: String,
				default: ''
			},
		},
		data() {
			return {

			}
		},
		methods: {
			closeDialog() {
				this.$emit('closeDialog')
			},
			confirmDialog() {
				this.$emit('confirmDialog')
			},
		}
	}
</script>

<style scoped>
	.podia {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		min-height: 100vh;
		background: rgba(0, 0, 0, 0.56);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.conbg {
		background: #F7F7F2;
		box-shadow: inset 0px 0px 64px 0px rgba(230, 255, 79, 0.29);
		border-radius: 16px;
		border: 1px solid #F6FFB2;
		position: relative;
	}

	.titletop {
		height: 64px;
		display: flex;
		position: relative;

		.title {
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 18px;
			color: #141414;
			position: absolute;
			left: 50%;
			transform: translate(-50%);
		}

		.closeimg {
			position: absolute;
			right: 20px;
		}
	}

	.contents {
		padding: 0 24px;
		max-height: 404px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #6D6F7A;
		line-height: 30px;
		overflow-y: scroll;
	}

	.contents::-webkit-scrollbar {
		display: none;
	}

	.footbotom {
		position: absolute;
		bottom: 16px;
		left: 50%;
		transform: translate(-50%);

		.btn {
			width: 116px;
			height: 36px;
			background: #F7F8FA;
			border-radius: 20px;
			border: 1px solid #DEDEDE;
			font-family: SourceHanSansCN, SourceHanSansCN;
			font-weight: 400;
			font-size: 14px;
			color: #141414;
		}

		.btn2 {
			background: #141414;
			color: #fff;
			margin-left: 36px;
		}
	}
</style>